/* eslint-disable import/prefer-default-export */
import { call, all, put, select } from 'redux-saga/effects'
import { prepareForSave } from '../firebase/document'
import getUserProfileFollowingIds from '../../../dataservices/getUserProfileFollowingIds'
import getUserProfileKitsCreatedByModifiedTimestamp from '../../../dataservices/getUserProfileKitsCreatedByModifiedTimestamp'
import getKitByKitId from '../../../dataservices/getKitByKitId'
import getShortName from '../../../utilities/Data/User/getShortName'
import getUsername from '../../../utilities/Data/User/getUsername'
import actions from '../../actionCreators'
import { selectUserProfile } from '../../selectors'

export function* getParamsForPostSet(params) {
	const postDraft = yield call(prepareForSave, params.postDraft)
	const userProfile = yield select(selectUserProfile)
	postDraft.user = getShortName({ userProfile })
	postDraft.userName = getUsername({ userProfile })
	return {
		...params,
		postDraft
	}
}

export function* getParamsForFollowersSet(params) {
	const follower = yield call(prepareForSave, {})
	return {
		...params,
		follower
	}
}

export function* getFollowing(params) {
	const followingIds = yield call(getUserProfileFollowingIds, { uid: params.uid })
	return { followingIds }
}

export function getPostIds(params) {
	return {
		...params,
		postIds: params.feed ? params.feed.map(f => f.postId) : [(params.post && params.post.postId)]
	}
}

export function* getKitsByKitsCreated(kitsCreatedDocs = []) {
	const results = yield all(kitsCreatedDocs.map(function* get(kitsCreated) {
		try {
			return yield call(getKitByKitId, { kitId: kitsCreated.kitId })
		} catch (error) {
			if (error.details && error.details[0] && error.details[0].reason === 'deleted') {
				return yield put(actions.fetchWarning(error))
			}
			return yield put(actions.fetchFatalError(error)) // this will have no kit member
		}
	}))
	return results.filter(result => result.kit).map(result => result.kit)
}

export function* getKitsCreated({ userProfile, limit }) {
	const kitsCreatedDocs = yield call(getUserProfileKitsCreatedByModifiedTimestamp, { uid: userProfile.uid, limit })
	const kits = yield call(getKitsByKitsCreated, kitsCreatedDocs)
	return { kits }
}



// WEBPACK FOOTER //
// ./src/redux/saga/posts/sagas.js